<template>
  <b-overlay
      :show="overlay"
      rounded="sm"
  >
    <div v-if="products !== null" style="height: inherit">

    <!-- ECommerce Header -->
    <section id="ecommerce-header">
      <div class="row">
        <div class="col-sm-12">
          <div class="ecommerce-header-items">
            <div class="result-toggler">
              <feather-icon
                icon="MenuIcon"
                class="d-block d-lg-none"
                size="21"
                @click="mqShallShowLeftSidebar = true"
              />
              <div class="search-results">
                {{ totalCount }} محصول یافت شد
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Overlay -->
    <div class="body-content-overlay" />

    <!-- Searchbar -->
    <div class="ecommerce-searchbar mt-1">
      <b-row>
        <b-col md="10" cols="12">
          <b-input-group class="input-group-merge">
            <b-form-input
              v-model="searchQuery"
              placeholder="جستجوی محصولات"
              class="search-product"
            />
            <b-input-group-append is-text>
              <feather-icon
                icon="SearchIcon"
                class="text-muted"
              />
            </b-input-group-append>
          </b-input-group>
        </b-col>
        <b-col
            cols="12"
            md="2"
            class="d-flex align-items-center justify-content-start mb-md-0"
        >
          <b-button
              variant="success"
              class=""
              :block="$store.getters['app/currentBreakPoint'] === 'xs'"
              @click="downloadFile"
          >
            دانلود اکسل لیست
          </b-button>
        </b-col>
      </b-row>
    </div>

    <!-- Prodcuts -->
    <section :class="itemView">
      <b-card
        v-for="product in products"
        :key="product.productId"
        class="ecommerce-card"
        no-body
      >
        <div class="item-img text-center pt-0">
          <b-link class="w-100 position-relative" :to="{ name: 'apps-e-commerce-product-details', params: { id: product.productId } }">
            <b-img
              :alt="`${product.name}-${product.productId}`"
              fluid
              class="card-img-top"
              :src="baseUrl+product.imageFile"
            />
            <b-badge
                v-if="product.fileData !== ''"
                class="product-badge p-1"
                variant="light-primary"
            >
              دارای مدیا
            </b-badge>
          </b-link>
        </div>

        <!-- Product Details -->
        <b-card-body>
          <div class="item-wrapper">
            <h6 class="item-name">
              <b-link
                  class="text-body"
                  :to="{ name: 'apps-e-commerce-product-details', params: { id: product.productId } }"
              >
                {{ product.title }}
              </b-link>
            </h6>
            <div>
              <h6  v-if="!product.isFree" class="item-price text-info">
                {{ makePrettyPrice(product.price) }} تومان
              </h6>
            </div>
          </div>

          <b-card-text v-html="product.description" class="item-description"></b-card-text>

          <b-badge
              v-if="product.type === 1"
              variant="warning"
              class="d-inline-block"
          >
            دوره
          </b-badge>
          <b-badge
              v-else-if="product.type === 2"
              variant="warning"
          >
            فیلم
          </b-badge>
          <b-badge
              v-else-if="product.type === 3"
              variant="warning"
          >
            فایل
          </b-badge>
          <b-badge
              v-else-if="product.type === 4"
              variant="warning"
          >
            پادکست
          </b-badge>
          <b-badge class="ml-1" variant="info">
            <feather-icon
                icon="EyeIcon"
                class="mr-25"
            />
            <span> {{ product.viewCounts }}</span>
          </b-badge>
        </b-card-body>

        <!-- Product Actions -->
        <div class="item-options text-center">
          <div v-if="!product.isFree" class="item-wrapper">
            <div class="item-cost">
              <h4 class="item-price">
                {{ makePrettyPrice(product.price) }} تومان
              </h4>
            </div>
          </div>
          <b-button
            variant="danger"
            tag="a"
            class="btn-wishlist"
            v-b-modal.modal-delete
            @click="showModal(product.productId)"
          >
            <feather-icon
              icon="TrashIcon"
              class="mr-50"
              :class="{'text-danger': product.isInWishlist}"
            />
            <span>حذف</span>
          </b-button>
          <b-button
            variant="light"
            tag="a"
            class="btn-cart"
            @click.prevent="$router.push({ name: 'apps-e-commerce-product-details', params: { id: product.productId } })"
          >
            <feather-icon
              icon="EditIcon"
              class="mr-50"
            />
            <span>ویرایش</span>
          </b-button>
          <b-button
              v-if="product.type !== 6 && product.type !== 7"
              variant="info"
              tag="a"
              class="btn-cart"
              @click.prevent="goToUploadMediaUrl(product)"
          >
            <feather-icon
                icon="CastIcon"
                class="mr-50"
            />
            <span>مدیا</span>
          </b-button>
          <b-button
              v-if="product.type === 8"
              variant="success"
              tag="a"
              class="btn-cart"
              @click.prevent="$router.push({ name: 'apps-question-title', params: { title: product.title , id:product.psychologicalTestId } })"
          >
            <feather-icon
                icon="CastIcon"
                class="mr-50"
            />
            <span>لیست سوالات</span>
          </b-button>
          <b-button
              v-if="product.type === 6"
              variant="info"
              tag="a"
              class="btn-cart"
              @click.prevent="$router.push({ name: 'apps-e-commerce-packages-list-id', params: { id: product.productId }})"
          >
            <feather-icon
                icon="ArchiveIcon"
                class="mr-50"
            />
            <span>محصولات</span>
          </b-button>
          <b-button
              v-if="product.type === 7"
              variant="info"
              tag="a"
              class="btn-cart"
              @click.prevent="$router.push({ name: 'apps-package-list-id', params: { id: product.bundleId }})"
          >
            <feather-icon
                icon="ArchiveIcon"
                class="mr-50"
            />
            <span>محصولات</span>
          </b-button>
<!--          <b-button-->
<!--              variant="warning"-->
<!--              tag="a"-->
<!--              class="btn-wishlist"-->
<!--              @click.prevent="$router.push({ name: 'apps-e-commerce-add-product-comment', params: { id: product.productId }})"-->
<!--          >-->
<!--            <feather-icon-->
<!--                icon="MessageSquareIcon"-->
<!--                class="mr-50"-->
<!--            />-->
<!--            <span>ارسال اکسل نظرات</span>-->
<!--          </b-button>-->
        </div>
      </b-card>
    </section>

    <!-- Pagination -->
    <section>
      <b-row>
        <b-col cols="12">
          <b-pagination
            v-model="currentPage"
            :total-rows="totalCount"
            per-page="9"
            first-number
            align="center"
            last-number
            prev-class="prev-item"
            next-class="next-item"
          >
            <template #prev-text >
              <feather-icon style="transform: rotate(180deg)"
                icon="ChevronLeftIcon"
                size="18"
              />
            </template>
            <template #next-text>
              <feather-icon
                icon="ChevronRightIcon"
                size="18"
              />
            </template>
          </b-pagination>
        </b-col>
      </b-row>
    </section>

    <!-- Sidebar -->
    <portal to="content-renderer-sidebar-detached-left">
      <shop-left-filter-sidebar
          :filters="filters"
          :filter-options="filterOptions"
          :categories="productCategories"
          :mq-shall-show-left-sidebar.sync="mqShallShowLeftSidebar"
          :types="types"
          @changeCategory="changeCategory"
          @changeType="changeType"
      />
    </portal>
  </div>
    <b-modal
        id="modal-delete"
        centered
        ok-title="حذف"
        cancelTitle="انصراف"
        @ok="deleteProduct(deleteItem)"
    >
      <span>حذف شود؟</span>
    </b-modal>
  </b-overlay>
</template>

<script>
import {
  BBadge,
  BButton,
  BCard,
  BCardBody,
  BCardText,
  BCol,
  BFormInput,
  BImg,
  BInputGroup,
  BInputGroupAppend,
  BLink,
  BModal,
  BOverlay,
  BPagination,
  BRow
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { watch } from '@vue/composition-api'
import { useResponsiveAppLeftSidebarVisibility } from '@core/comp-functions/ui/app'
import ShopLeftFilterSidebar from './ECommerceShopLeftFilterSidebar.vue'
import { useShopFiltersSortingAndPagination, useShopRemoteData, useShopUi } from './useECommerceShop'
import { useEcommerceUi } from '../useEcommerce'
import {
  ProductCategoryGetAllCourseCategoriesRequest,
  ProductDeleteProductRequest,
  ProductGetAllRequest
} from '@/libs/Api/Product'
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import Helper from '@/libs/Helper'
import { getUserData } from '@/auth/utils'
import axiosIns from '@/libs/axios'
import { saveAs } from 'file-saver'

export default {
  title: 'لیست محصولات - پنل ادمین نهایی شو',
  data(){
    return{
      products:null,
      overlay:false,
      baseUrl:Helper.baseUrl,
      totalCount:null,
      productCategories:null,
      deleteItem:null,
      currentPage:1,
      searchQuery:'',
      categoryId:0,
      type:1,
      types:[
        {label : 'دوره‌ها' , value : 1},
        // {label : 'فیلم' , value : 2},
        // {label : 'کتاب‌ها' , value : 3},
        // {label : 'پادکست‌ها' , value : 4},
        // {label : 'مدرسه نهایی شو' , value : 6},
        // {label : 'پکیج‌ها' , value : 7},
        // {label : 'تست‌های روانشناسی' , value : 8},
      ],
      defaultGetProductData:{
        categoryId:0,
        searchByTitle:'',
        pageNumber:1,
        count:9,
        type:1
      }
    }
  },
  async created(){
    await this.getProducts(this.defaultGetProductData.pageNumber,this.defaultGetProductData.searchByTitle,this.defaultGetProductData.categoryId,this.defaultGetProductData.type);
    await this.getCategories();
  },
  methods:{
    async getProducts(pageNumber,search,categoryId,type){
      let _this = this;
      _this.overlay = true;
      let getProductData={
        categoryId:categoryId,
        searchByTitle:search,
        pageNumber:pageNumber,
        count:9,
        type:type,
        isFree:''
      }

      let productGetAllRequest = new ProductGetAllRequest(_this);
      productGetAllRequest.setParams(getProductData)
      await productGetAllRequest.fetch(function (content){
        _this.overlay = false;
        _this.products = content.products;
        _this.totalCount = content.productsCount;
      } , function (content){
        _this.overlay = false;
      });
    },
    async getCategories(){
      let _this = this;
      _this.overlay = true;
      let getCategoriesData = {
        pageNumber : 0,
        count : 0
      }

      let productCategoryGetAllRequest = new ProductCategoryGetAllCourseCategoriesRequest(_this);
      productCategoryGetAllRequest.setParams(getCategoriesData);
      await productCategoryGetAllRequest.fetch(function (content){
        _this.overlay = false;
        _this.productCategories = content.productCategories;
        const order = [
          'پایه دهم - ریاضی',
          'پایه دهم - تجربی',
          'پایه یازدهم - ریاضی',
          'پایه یازدهم - تجربی',
          'پایه دوازدهم ریاضی',
          'پایه دوازدهم تجربی',
          'گروه انسانی',
          'یوگا و مدیتیشن'
        ]
        _this.productCategories = _this.productCategories.sort(
            (a, b) => order.indexOf(a.name) - order.indexOf(b.name)
        )

      },function (error){
        _this.overlay = false;
      })
    },
    async deleteProduct(param){
      let _this = this;
      _this.overlay = true;

      let productDeleteProductRequest = new ProductDeleteProductRequest(_this);
      productDeleteProductRequest.setId(param)
      await productDeleteProductRequest.fetch(function (content){
        _this.overlay = false;
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: `عملیات موفق`,
            icon: 'CheckIcon',
            variant: 'success',
            text: `حذف شد.`,
          },
        })
        _this.getProducts(_this.defaultGetProductData.pageNumber,_this.defaultGetProductData.searchByTitle,_this.defaultGetProductData.categoryId,_this.defaultGetProductData.type);
      } , function (error){
        _this.overlay = false;});
    },
    changeCategory(param){
      this.defaultGetProductData.categoryId = param;
    },
    changeType(param){
      this.defaultGetProductData.type = param;
    },
    makePrettyPrice(param){
      return Helper.prettyPrice(param,0)
    },
    showModal(param){
      let _this = this;
      _this.deleteItem = param
    },
    async downloadFile() {
      let _this = this;
      _this.overlay = true;
      let userToken = getUserData().token;

      await axiosIns.post(`Product/GenerateProductExcel`, null, {
        responseType: 'blob',
        'Authorization': userToken,
        'Token': userToken,
      }).then(resp => {
        _this.overlay = false;
        saveAs(resp.data, 'لیست محصولات.xlsx');
      })
          .catch((error) => {
            _this.overlay = false;
            console.log(error);
          });
    },
    goToUploadMediaUrl(product){
      if (product.type === 8 && product.psychologicalTestType === 4){
        this.$router.push({ name: 'apps-e-commerce-AddMediaToTest', params: { id: product.productId } , query : {productType : product.type} })
      }else {
        this.$router.push({ name: 'apps-e-commerce-add-product-media', params: { id: product.productId } , query : {productType : product.type} })
      }
    }
  },
  watch:{
    currentPage:function (nv,ov) {
      this.getProducts(nv,this.defaultGetProductData.searchByTitle,this.defaultGetProductData.categoryId,this.defaultGetProductData.type);
    },
    searchQuery:function (nv,ov){
      this.getProducts(this.defaultGetProductData.pageNumber,nv,this.defaultGetProductData.categoryId,this.defaultGetProductData.type);
    },
    'defaultGetProductData.categoryId':function (nv,ov){
      this.getProducts(this.defaultGetProductData.pageNumber,this.defaultGetProductData.searchByTitle,nv,this.defaultGetProductData.type);
    },
    'defaultGetProductData.type':function (nv,ov){
      this.getProducts(this.defaultGetProductData.pageNumber,this.defaultGetProductData.searchByTitle,this.defaultGetProductData.categoryId,nv);
    },
  },
  directives: {
    Ripple,
  },
  components: {
    // BSV
    BRow,
    BCol,
    BInputGroup,
    BInputGroupAppend,
    BFormInput,
    BCard,
    BCardBody,
    BLink,
    BImg,
    BCardText,
    BButton,
    BPagination,
    BOverlay,
    BBadge,
    BModal,

    // SFC
    ShopLeftFilterSidebar,
  },
  setup() {
    const {
      filters, filterOptions, sortBy, sortByOptions,
    } = useShopFiltersSortingAndPagination()

    const { handleCartActionClick, toggleProductInWishlist } = useEcommerceUi()

    const {
      itemView, itemViewOptions, totalProducts,
    } = useShopUi()

    const { products, fetchProducts } = useShopRemoteData()

    const { mqShallShowLeftSidebar } = useResponsiveAppLeftSidebarVisibility()

    // Wrapper Function for `fetchProducts` which can be triggered initially and upon changes of filters
    const fetchShopProducts = () => {
      fetchProducts({
        q: filters.value.q,
        sortBy: sortBy.value.value,
        page: filters.value.page,
        perPage: filters.value.perPage,
      })
        .then(response => {
          products.value = response.data.products
          totalProducts.value = response.data.total
        })
    }

    fetchShopProducts()

    watch([filters, sortBy], () => {
      fetchShopProducts()
    }, {
      deep: true,
    })

    return {
      // useShopFiltersSortingAndPagination
      filters,
      filterOptions,
      sortBy,
      sortByOptions,

      // useShopUi
      itemView,
      itemViewOptions,
      totalProducts,
      toggleProductInWishlist,
      handleCartActionClick,

      // useShopRemoteData
      products,

      // mqShallShowLeftSidebar
      mqShallShowLeftSidebar,
    }
  },
}
</script>

<style lang="scss">
@import "~@core/scss/base/pages/app-ecommerce.scss";
</style>

<style lang="scss" scoped>
.item-view-radio-group ::v-deep {
  .btn {
    display: flex;
    align-items: center;
  }
}
img{
  height: 25rem!important;
}
</style>
